/* LevelUp Wholesale pages: infinite product carousel + variation selector.
   Carousel contract, per Levi:
     - infinite scroll in both directions
     - the side fades and the centre focus frame NEVER move (they are siblings of the track)
     - products scroll into focus at full clarity (no dimming, no blur)
     - the name and an explicit "View <product>" CTA follow whatever is centred
     - clicking a side product centres it; clicking the centred one opens its page          */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initCarousel(root) {
    var track = root.querySelector('[data-car-track]');
    var tpl   = root.querySelector('[data-car-data]');
    var nameEl = root.querySelector('[data-car-name]');
    var goEl   = root.querySelector('[data-car-go]');
    var goName = root.querySelector('[data-car-goname]');
    if (!track || !tpl) return;

    var packs;
    try {
      var raw = (tpl.content ? tpl.content.textContent : tpl.innerHTML).trim();
      packs = JSON.parse(raw);
    } catch (e) { return; }
    if (!packs || !packs.length) return;

    var N = packs.length, COPIES = 3, MID = 1;
    var frag = document.createDocumentFragment();
    for (var c = 0; c < COPIES; c++) {
      for (var i = 0; i < N; i++) {
        var p = packs[i];
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'wlp-car__cell';
        b.setAttribute('role', 'option');
        b.dataset.idx = String(i);
        var img = document.createElement('img');
        img.src = p.url; img.alt = p.name; img.loading = 'lazy'; img.decoding = 'async';
        b.appendChild(img);
        frag.appendChild(b);
      }
    }
    track.appendChild(frag);
    var cells = Array.prototype.slice.call(track.children);

    function setWidth() {
      return cells[N].getBoundingClientRect().left - cells[0].getBoundingClientRect().left;
    }
    function centreOffsetFor(cell) {
      // scrollLeft that puts this cell's centre on the track's centre
      return cell.offsetLeft + cell.offsetWidth / 2 - track.clientWidth / 2;
    }

    var anim = null;
    function tweenTo(target) {
      if (anim) cancelAnimationFrame(anim);
      if (reduce) { track.scrollLeft = target; return; }
      // scroll-snap: mandatory cancels a programmatic smooth scroll, so tween by hand
      var prevSnap = track.style.scrollSnapType;
      track.style.scrollSnapType = 'none';
      var from = track.scrollLeft, dist = target - from, t0 = performance.now(), dur = 380;
      var ease = function (p) { return 1 - Math.pow(1 - p, 3); };
      (function step(now) {
        var p = Math.min(1, (now - t0) / dur);
        track.scrollLeft = from + dist * ease(p);
        if (p < 1) { anim = requestAnimationFrame(step); }
        else { anim = null; track.style.scrollSnapType = prevSnap; normalise(); }
      })(t0);
    }

    // keep the scroll position inside the middle copy so it can wrap forever
    function normalise() {
      var w = setWidth();
      if (!w) return;
      if (track.scrollLeft < w * 0.5) track.scrollLeft += w;
      else if (track.scrollLeft > w * 1.5) track.scrollLeft -= w;
    }

    var activeIdx = -1;
    function syncActive() {
      var tr = track.getBoundingClientRect(), mid = tr.left + tr.width / 2;
      var best = null, bestD = Infinity;
      for (var i = 0; i < cells.length; i++) {
        var r = cells[i].getBoundingClientRect();
        var d = Math.abs(r.left + r.width / 2 - mid);
        if (d < bestD) { bestD = d; best = cells[i]; }
      }
      if (!best) return;
      cells.forEach(function (c) { c.removeAttribute('aria-current'); });
      best.setAttribute('aria-current', 'true');
      var idx = +best.dataset.idx;
      if (idx === activeIdx) return;
      activeIdx = idx;
      var p = packs[idx];
      if (nameEl) nameEl.textContent = p.name;
      if (goName) goName.textContent = p.name;
      if (goEl) goEl.setAttribute('href', p.href);
    }

    // click: centre a side pack, open the centred one
    track.addEventListener('click', function (ev) {
      var cell = ev.target.closest('.wlp-car__cell');
      if (!cell) return;
      var target = centreOffsetFor(cell);
      // if it is already as centred as it can get, treat the click as "open"
      if (Math.abs(target - track.scrollLeft) < 8) {
        var p = packs[+cell.dataset.idx];
        if (p && p.href) window.location.href = p.href;
        return;
      }
      tweenTo(target);
    });

    function step(dir) {
      var cur = cells.filter(function (c) { return c.getAttribute('aria-current') === 'true'; })[0] || cells[N];
      var at = cells.indexOf(cur) + dir;
      at = Math.max(0, Math.min(cells.length - 1, at));
      tweenTo(centreOffsetFor(cells[at]));
    }
    var prev = root.querySelector('[data-car-prev]'), next = root.querySelector('[data-car-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
      if (e.key === 'Enter' || e.key === ' ') {
        var p = packs[activeIdx]; if (p && p.href) { e.preventDefault(); window.location.href = p.href; }
      }
    });

    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; syncActive(); if (!anim) normalise(); });
    }, { passive: true });

    // start centred on this page's own product, in the middle copy
    function start() {
      var want = root.getAttribute('data-active') || '';
      var at = 0;
      for (var i = 0; i < N; i++) { if (packs[i].slug === want) { at = i; break; } }
      var cell = cells[MID * N + at];
      var prevSnap = track.style.scrollSnapType;
      track.style.scrollSnapType = 'none';
      track.scrollLeft = centreOffsetFor(cell);
      track.style.scrollSnapType = prevSnap;
      syncActive();
    }
    if (document.readyState === 'complete') start();
    else window.addEventListener('load', start);
    start();
    window.addEventListener('resize', function () { start(); });
  }

  function initVariations(root) {
    var chips = root.querySelectorAll('[data-var-chip]');
    if (!chips.length) return;
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var val = chip.getAttribute('data-var-chip');
        root.querySelectorAll('[data-var-chip]').forEach(function (c) {
          var on = c === chip;
          c.classList.toggle('is-on', on);
          if (on) c.setAttribute('aria-current', 'true'); else c.removeAttribute('aria-current');
        });
        root.querySelectorAll('[data-var-row]').forEach(function (r) {
          r.hidden = r.getAttribute('data-var-row') !== val;
        });
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-wlp-car]').forEach(initCarousel);
    document.querySelectorAll('[data-wlp-var]').forEach(initVariations);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
